import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/ged/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/facture",
    name: "Facture",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ged/Facture"),
  },
  {
    path: "/bordereau",
    name: "Bordereau",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ged/Bordereau"),
  },
  {
    path: "/contrat",
    name: "Contrat",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ged/Contrat"),
  },
  {
    path: "/tier",
    name: "Tier",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ged/Tier"),
  },
  {
    path: "/marche",
    name: "Marche",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ged/Marche"),
  },
  {
    path: "/commande",
    name: "Commande",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ged/Commande"),
  },
  {
    path: "/user",
    name: "User",
    component: () => import(/* webpackChunkName: "about" */ "../views/User"),
  },
  {
    path: "/od",
    name: "Od",
    component: () => import(/* webpackChunkName: "about" */ "../views/ged/Od"),
  },
  {
    path: "/mission",
    name: "Mission",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ged/Mission"),
  },
  {
    path: "/autredocumentcomptable",
    name: "Autredocumentcomptable",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/ged/AutreDocumentComptable"
      ),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
